import { types as sdkTypes } from '../../../util/sdkLoader';
import { REVIEW_TYPE_OF_PROVIDER } from '../../../util/types';

const { UUID } = sdkTypes as { UUID: new (id: string) => any };

type MockReviewSeed = {
  id: string;
  rating: number;
  content: string;
  daysAgo: number;
  authorId: string;
  authorDisplay: string;
  authorAbbrev: string;
};

const SEEDS: MockReviewSeed[] = [
  {
    id: 'mock-review-1',
    rating: 5,
    content:
      'Exactly as described. The seller had everything staged, counted, and ready for pickup. Smooth escrow release after inspection.',
    daysAgo: 14,
    authorId: 'mock-author-1',
    authorDisplay: 'Mark R',
    authorAbbrev: 'MR',
  },
  {
    id: 'mock-review-2',
    rating: 5,
    content:
      'Fast communication and very professional handoff. We saved a lot on premium studs and the quality was excellent.',
    daysAgo: 30,
    authorId: 'mock-author-2',
    authorDisplay: 'Alicia T',
    authorAbbrev: 'AT',
  },
  {
    id: 'mock-review-3',
    rating: 4,
    content:
      'Reliable to work with and easy to coordinate around job-site hours. Would buy from them again.',
    daysAgo: 60,
    authorId: 'mock-author-3',
    authorDisplay: 'Jamal P',
    authorAbbrev: 'JP',
  },
  {
    id: 'mock-review-4',
    rating: 5,
    content:
      'Pickup was organized, materials were clean, and quantities matched the listing exactly.',
    daysAgo: 90,
    authorId: 'mock-author-4',
    authorDisplay: 'Denise C',
    authorAbbrev: 'DC',
  },
  {
    id: 'mock-review-5',
    rating: 5,
    content:
      'Clear communication from start to finish. The escrow handoff felt secure and straightforward.',
    daysAgo: 120,
    authorId: 'mock-author-5',
    authorDisplay: 'Leo S',
    authorAbbrev: 'LS',
  },
  {
    id: 'mock-review-6',
    rating: 4,
    content: 'Professional seller with accurate photos and solid job-site coordination.',
    daysAgo: 150,
    authorId: 'mock-author-6',
    authorDisplay: 'Priya M',
    authorAbbrev: 'PM',
  },
];

const buildMockReview = (seed: MockReviewSeed) => {
  const createdAt = new Date(Date.now() - seed.daysAgo * 24 * 60 * 60 * 1000);
  return {
    id: new UUID(seed.id),
    type: 'review',
    attributes: {
      type: REVIEW_TYPE_OF_PROVIDER,
      state: 'public',
      rating: seed.rating,
      content: seed.content,
      createdAt,
    },
    author: {
      id: new UUID(seed.authorId),
      type: 'user',
      attributes: {
        profile: {
          displayName: seed.authorDisplay,
          abbreviatedName: seed.authorAbbrev,
        },
      },
    },
  };
};

/**
 * Sharetribe-shaped mock reviews used as a placeholder while the marketplace
 * has no real provider reviews yet (so the operator can see the design).
 * Each entity matches the propTypes in `util/types.js` exactly.
 */
export const MOCK_PROVIDER_REVIEWS = SEEDS.map(buildMockReview);
